import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { BodyCheckPermiso, dataFuncionalidades, dataRoles, SegmentosCompaniaGeneral, SegmentosCorporativoGeneral } from '../models';
import { environment } from '../../../environments/environment';
import { RolRbac } from '../models/rbac.model';

@Injectable({
  providedIn: 'root'
})
export class RbacService {
  private headerAuthToken: HttpHeaders;
  private loaderSubject = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this.loaderSubject.asObservable();

  constructor(private http: HttpClient) {
    this.headerAuthToken = new HttpHeaders({
      "Content-Type": "application/json",
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`
    })
  }

  public getPermission(body: BodyCheckPermiso): Observable<boolean> {
    this.showLoaderPermission();
    return this.http.post<boolean>(`${environment.url_rbac}/api/v1/check/rol`, JSON.stringify(body), { headers: this.headerAuthToken }).pipe(
      finalize(() => this.hideLoaderPermission() )
    );
  }

  public showLoaderPermission(): void {
    this.loaderSubject.next(true);
  }

  public hideLoaderPermission(): void {
    this.loaderSubject.next(false);
  }

  public getRoles(): Observable<dataRoles[]> {
    return this.http.get<dataRoles[]>(`${environment.url_rbac}/api/v1/roles`, {
      headers: this.headerAuthToken,
    });
  }

  public getSegmentos(): Observable<SegmentosCorporativoGeneral[]> {
    return this.http.get<SegmentosCorporativoGeneral[]>(
      `${environment.url_rbac}/api/v1/segmentos`,
      { headers: this.headerAuthToken }
    );
  }

  public getFuncionalidades(): Observable<dataFuncionalidades[]> {
    return this.http.get<dataFuncionalidades[]>(`${environment.url_rbac}/api/v1/funcionalidades`, {
      headers: this.headerAuthToken,
    });
  }

  public getRolById(rol: string) : Observable<RolRbac> {
    return this.http.get<RolRbac>(`${environment.url_rbac}/api/v1/rol?identificador=${rol}`, {
      headers: this.headerAuthToken,
    });
  }

  public crearRol(data: any): Observable<any> {
    return this.http.post(`${environment.url_rbac}/api/v1/rol`, data, {
      headers: this.headerAuthToken
    });
  }

  public editarRol(data: any): Observable<any> {
    return this.http.put(`${environment.url_rbac}/api/v1/rol?identificador=${data.identificador}`, data, {
      headers: this.headerAuthToken
    });
  }
}
